import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess, toastInfo } from './toast';
import { tokenExpired } from './auth';
import {
    MOVE_SCOUT_GROUP_COLUMN,
    MOVE_SCOUT_MEMBER_CARD,
    KANBAN_GET_SCOUT_GROUP_LIST_REQUEST,
    KANBAN_GET_SCOUT_GROUP_LIST,
    SCOUT_GROUP_SAVE_REQUEST,
    SCOUT_GROUP_SAVE_SUCCESS,
    SCOUT_GROUP_SAVE_FAILURE,
    SCOUT_GET_GEO_REGION_REQUEST,
    SCOUT_GET_GEO_REGION,
    SCOUT_GET_FARM_USERS_LIST_REQUEST,
    SCOUT_GET_FARM_USERS_LIST,
    ADD_SCOUT_GROUP,
    REMOVE_SCOUT_MEMBER,
    REMOVE_SCOUT_GROUP,
    EDIT_SCOUT_GROUP,
    SET_SCOUT_SEARCH_TEXT,
    SCOUT_GROUP_SELECTION,
    RESET_SCOUT_GROUP,
    SET_SCOUT_ACTIVE_TAB
} from "../constants/action-types";
import { getSearchDateRange } from '../helpers/common';
import { DELETE_SCOUT_GROUP_SUCCESS, SAVE_SCOUT_GROUP } from '../constants/messages';

export const moveColumn = payload => ({ type: MOVE_SCOUT_GROUP_COLUMN, payload });

export const moveCard = payload => (dispatch) => {
    dispatch({ type: MOVE_SCOUT_MEMBER_CARD, payload })
}

export const scoutGroupListRequest = () => ({ type: KANBAN_GET_SCOUT_GROUP_LIST_REQUEST });

export const scoutGroupList = (data, range) => ({ type: KANBAN_GET_SCOUT_GROUP_LIST, payload: data });

export const scoutGroupSaveRequest = () => ({ type: SCOUT_GROUP_SAVE_REQUEST });

export const scoutGroupSaveSuccess = (sgList) => ({ type: SCOUT_GROUP_SAVE_SUCCESS, sgList });

export const scoutGroupSaveFailure = () => ({ type: SCOUT_GROUP_SAVE_FAILURE });

export const geoRegionListRequest = () => ({ type: SCOUT_GET_GEO_REGION_REQUEST });

export const geoRegionList = (data) => ({ type: SCOUT_GET_GEO_REGION, payload: data });

export const farmUsersListRequesting = () => ({ type: SCOUT_GET_FARM_USERS_LIST_REQUEST });

export const farmUsersList = payload => ({ type: SCOUT_GET_FARM_USERS_LIST, payload });

export const addNewScoutGroup = payload => ({ type: ADD_SCOUT_GROUP, payload });

export const editScoutGroup = payload => ({ type: EDIT_SCOUT_GROUP, payload });

export const removeScoutMember = payload => ({ type: REMOVE_SCOUT_MEMBER, payload });

export const removeScoutGroup = payload => ({ type: REMOVE_SCOUT_GROUP, payload });

export const setScoutSearchText = (searchText) => ({ type: SET_SCOUT_SEARCH_TEXT, searchText });

export const scoutGroupSelection = payload => ({ type: SCOUT_GROUP_SELECTION, payload });

export const resetScoutGroup = () => ({ type: RESET_SCOUT_GROUP });

export const setScoutActiveTab = payload => ({ type: SET_SCOUT_ACTIVE_TAB, payload });

export const getScoutGroupList = params => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to
    };

    dispatch(scoutGroupListRequest());
    defaultAgent.get('/api/scout/group/list', reqParams).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(scoutGroupList());
        } else if (agentResult.data) {
            dispatch(scoutGroupList(agentResult.data));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(scoutGroupList());
    });
}

export const saveScoutGroup = (farmId, addScoutData, cb) => (dispatch, getState) => {
    const state = getState();
    const sgListById = state.scoutKanban.sgListById;
    let scoutGroupList = [];

    if (addScoutData && addScoutData.length > 0) {
        scoutGroupList = addScoutData;
    } else {
        for (let sgItem in sgListById) {
            const payload = {
                scout_group_uuid: sgListById[sgItem].scout_group_uuid,
                scout_group_name: sgListById[sgItem].scout_group_name,
                scout_entity_type_id: sgListById[sgItem].scout_entity_type_id,
                scout_members: sgListById[sgItem].scout_member_list,
                status_id: sgListById[sgItem].status_id
            }
            scoutGroupList.push(payload);
        }
    }

    dispatch(scoutGroupSaveRequest());
    defaultAgent.put('/api/scout/group/bulk/save', { farm_uuid: farmId, scout_group: scoutGroupList })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === SAVE_SCOUT_GROUP.code) {
                dispatch(scoutGroupSaveSuccess(scoutGroupList));
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(scoutGroupSaveFailure());
                dispatch(toastError(agentResult.message));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
}

export const getGeoRegionList = (farmId, includeRemoved = false, range) => dispatch => {
    dispatch(geoRegionListRequest());
    const dateRange = range ? range : {};
    defaultAgent.get('/api/geo/region/list', { farm_uuid: farmId, include_removed: includeRemoved, ...dateRange })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(geoRegionList([], farmId));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data)
                dispatch(geoRegionList(agentResult.data, farmId));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getFarmUsersList = farmId => dispatch => {
    dispatch(farmUsersListRequesting());
    defaultAgent.get(`/api/farm/user/assigned?farm_uuid=${farmId}`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(farmUsersList(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const deleteScoutGroup = (data) => {
    return dispatch => {
        defaultAgent.put('/api/scout/group/delete', { scout_group_uuid: data.scout_group_uuid, farm_uuid: data.farm_uuid })
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === DELETE_SCOUT_GROUP_SUCCESS.code) {
                    dispatch(toastInfo(agentResult.message));
                    dispatch(getScoutGroupList({ farmId: data.farm_uuid }));
                    // dispatch(removeScoutGroup({ scoutGroupId: data.scout_group_uuid }));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}